import { render, staticRenderFns } from "./conversation-create.vue?vue&type=template&id=972315a2&"
import script from "./conversation-create.vue?vue&type=script&lang=ts&"
export * from "./conversation-create.vue?vue&type=script&lang=ts&"
import style0 from "./conversation-create.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports